import styled from "@emotion/styled/macro";
import { tokens } from "@sunrun/experience-ui-components";

type ExternalTextLinkProps = React.ComponentPropsWithoutRef<"a">;

const ExternalTextLink = ({
  target = "_blank",
  rel = "noopener noreferrer",
  ...props
}: ExternalTextLinkProps) => (
  <StyledExternalTextLink target={target} rel={rel} {...props} />
);

const StyledExternalTextLink = styled.a`
  color: ${tokens.BRAND_HERO_BLUE};
  text-decoration: underline;
  text-underline-offset: 4px;
  font-weight: 500;

  &:hover {
    opacity: 0.8;
  }
`;

export { ExternalTextLink };
